// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { dateStringResolver } from './dateStringResolver';
import { mapIsNewHomesDevelopment } from './mapIsNewHomesDevelopment';
import { buildShortPriceTitle } from './buildShortPriceTitle';
import { mapListOfTags } from './mapListOfTags';
import { mapTransports } from './mapTransports';
import { mapListingImage, mapOtherPropertyImages } from './mapImage';
import { mapListOfFeatures } from './mapListOfFeatures';
import { PublicationStatuses } from './publication';
import { formatPriceDrop } from './formatPriceDrop';

export function mergeListings(listingsDTO, resultKey = 'listings') {
    return (listingsDTO.results[resultKey] || []).map((listingDTO) => {
        return {
            ...listingDTO,
            listingId: listingDTO.listingId,
            price: listingDTO.pricing.label,
            priceDrop: formatPriceDrop(listingsDTO.priceDrop),
            priceTitle: listingDTO.pricing.qualifierLabel ?? '',
            shortPriceTitle: buildShortPriceTitle(
                listingDTO.pricing.qualifier,
                listingDTO.pricing.internalValue
            ),
            alternativeRentFrequencyLabel:
                listingDTO.pricing?.alternateRentFrequencyPrice?.label,
            tags: mapListOfTags(listingDTO),
            numberOfVideos: listingDTO.numVideos,
            numberOfFloorPlans: listingDTO.numFloorPlans,
            numberOfImages: listingDTO.numPropertyImages,
            address: listingDTO.displayAddress,
            publishedOn: dateStringResolver(listingDTO.firstPublishedDate),
            // TODO: is this used?
            publishedOnLabel: 'Listed on',
            availableFrom: dateStringResolver(listingDTO.availableFromDate),
            flag: !listingDTO.statusSummary
                ? null
                : listingDTO.statusSummary.label,
            transports: mapTransports(listingDTO),
            image: mapListingImage(listingDTO),
            features: mapListOfFeatures(listingDTO),
            otherPropertyImages: mapOtherPropertyImages(listingDTO),
            displayType: listingDTO.displayType ?? '',
            listingUris: listingDTO.listingUris,
            location: {
                coordinates: {
                    ...(listingDTO?.location?.coordinates || {}),
                    isApproximate: false
                }
            },
            publicationStatus: PublicationStatuses.Live,
            isNewHomesDevelopment: mapIsNewHomesDevelopment(listingDTO),
            summaryDescription: listingDTO.summaryDescription
        };
    });
}
